exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-text.over-time {\n    color: var(--primary);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/check-out/check-out.component.css
// module id = ../../../../../src/app/shared/components/check-out/check-out.component.css
// module chunks = main